import React, {FC} from 'react';
import Image from 'next/image';

import {categoryTierFor} from '../../../../scoring';
import {ScoreResult} from '../../../../scoring/types';
import {HEADLINE_BY_TIER} from '../../constants';
import {filledSegmentCount} from '../../utils';
import AdvisorCard from '../AdvisorCard';
import Disclaimer from '../Disclaimer';

import Dial from './components/Dial';
import ScoreBreakdown from './components/ScoreBreakdown';

import styles from './styles.module.scss';

export interface ResultsViewProps {
  firstName?: string;
  result: ScoreResult;
}

const ResultsView: FC<ResultsViewProps> = ({firstName, result}) => {
  const clampedScore = Math.max(0, Math.min(100, result.finalScore));
  const tier = categoryTierFor(clampedScore);

  return (
    <div className={styles.resultsView}>
      <header className={styles.resultsView__navbar}>
        <Image
          src="/static/img/zoe-logo/Zoe Logo White.svg"
          alt="Financial Health Score"
          width={80}
          height={40}
        />
      </header>

      <main className={styles.resultsViewContainer}>
        <div className={styles.resultsViewContainer__topRow}>
          <div className={styles.resultsViewContainer__topRow_hero}>
            <p className={styles.resultsViewContainer__topRow_greeting}>
              {firstName ? `${firstName},` : 'Hi,'}
            </p>
            <h3 className={styles.resultsViewContainer__topRow_headline}>
              {HEADLINE_BY_TIER[tier]}
            </h3>
            <Dial
              score={clampedScore}
              filledCount={filledSegmentCount(clampedScore)}
              tier={tier}
            />
          </div>
          <AdvisorCard investableAssets={result.investableAssets} />
        </div>

        <ScoreBreakdown result={result} firstName={firstName} />
        <Disclaimer />
      </main>
    </div>
  );
};

export default ResultsView;
